export default function () {
  let window = `relatorio.leiloes.ata`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Ata de Realização de Leilão',
    width: '600',
    height: '300',
    minHeight: '300px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./Ata.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
